import { Container, Tag } from "@fluidattacks/design";
import _ from "lodash";
import { useTheme } from "styled-components";

import { Status } from "../../../formatters/status";
import type { IVulnerabilityModalHeaderDescription } from "../../types";
import { reachabilityFormatter } from "features/vulnerabilities/formatters/reachability";
import { techniqueFormatter } from "features/vulnerabilities/formatters/technique";
import { getOriginIcon } from "features/vulnerabilities/utils";
import { ReachabilityStatus, VulnerabilityOrigin } from "gql/graphql";
import { useAuthz } from "hooks/use-authz";
import { severityFormatter } from "utils/format-helpers";

const VulnerabilityModalHeaderDescription: React.FC<
  IVulnerabilityModalHeaderDescription
> = ({
  currentRow,
  cvssVersion,
  labels,
}: Readonly<IVulnerabilityModalHeaderDescription>): JSX.Element => {
  const theme = useTheme();
  const { hasAttribute } = useAuthz();
  const {
    advisories,
    technique,
    origin,
    severityThreatScore,
    severityTemporalScore,
    state,
  } = currentRow;
  const borderColor = `1px solid ${theme.palette.gray[200]}`;
  const severity =
    cvssVersion === "severityThreatScore"
      ? severityThreatScore
      : severityTemporalScore;

  const isAdvanced = hasAttribute("has_advanced");

  const reachabilityStatus =
    advisories?.reachabilityStatus ?? ReachabilityStatus.Latent;

  return (
    <Container
      alignItems={"flex-start"}
      display={"inline-flex"}
      flexDirection={"column"}
      width={"100%"}
    >
      <Container alignItems={"center"} display={"flex"}>
        <Container alignItems={"center"} display={"flex"}>
          {severityFormatter(severity)}
        </Container>
        <Container
          alignItems={"center"}
          borderLeft={borderColor}
          display={"flex"}
          gap={0.5}
          ml={0.5}
          pl={0.5}
        >
          <Tag
            icon={getOriginIcon(origin)}
            priority={"low"}
            tagLabel={_.capitalize(origin)}
            variant={"info"}
          />
          {techniqueFormatter(technique, isAdvanced)}
        </Container>
        <Container
          alignItems={"center"}
          borderLeft={borderColor}
          display={"flex"}
          gap={0.5}
          ml={0.5}
          pl={0.5}
        >
          <Status size={"12px"} status={labels[state]} />
          {origin === VulnerabilityOrigin.Inherited &&
            reachabilityFormatter(reachabilityStatus)}
        </Container>
      </Container>
    </Container>
  );
};

export { VulnerabilityModalHeaderDescription };
